webpackJsonp([6],{

/***/ "3YAd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _throttle = __webpack_require__("+X65");

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapper = document.querySelector('.c-logo'); /**
                                                  * @summary Site logo display helper.
                                                  */

var main = document.querySelector('.c-logo__main');
var hand = document.querySelector('.c-logo__hand');

var handShown = false;

hand.style.display = 'block';
hand.style.height = '1px';

/**
 * @summary Maintains logo layout.
 */
function maintain() {
	var mainRectangle = main.getBoundingClientRect();
	var handRectangle = hand.getBoundingClientRect();

	// Hand is under the main logo
	if (mainRectangle.left > handRectangle.left) {

		// Force syncing of height
		wrapper.style.height = mainRectangle.height + 'px';

		// Hand is already hidden, bail
		if (!handShown) {
			return;
		}

		hand.style.height = '1px';
		hand.style.opacity = 0;
		handShown = false;
	} else if (!handShown) {

		// Reset styles
		wrapper.style.height = '';
		hand.style.height = '';
		hand.style.opacity = 1;

		handShown = true;
	}
}

setTimeout(maintain, 0);
window.addEventListener('resize', (0, _throttle2.default)(maintain, 200));

/***/ }),

/***/ "BpTR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__("Dd8w");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _MenuItem = __webpack_require__("Xpq3");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Menu List preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
/**
 * @summary Contains the Menu List preact component.
 */

var Menu = function (_Component) {
	(0, _inherits3.default)(Menu, _Component);

	function Menu() {
		(0, _classCallCheck3.default)(this, Menu);
		return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	}

	/**
  * @summary Returns classes attribute value for a menu list.
  *
  * @param {('normal'|'drawer')} type  The type of menu.
  * @param {Number} depth The depth of the menu.
  * @returns {String} The class attribute value.
  */
	Menu.prototype.menuClasses = function menuClasses(type, depth) {
		return this[type + 'MenuClasses'](depth);
	};

	/**
  * @summary Returns classes attribute value for a normal menu list.
  *
  * @param {Number} depth The depth of the menu.
  * @returns {String} The class attribute value.
  */


	Menu.prototype.normalMenuClasses = function normalMenuClasses(depth) {
		if (depth === 0) {
			return 'c-primary-menu__top-menu';
		}

		return 'c-primary-menu__sub-menu ' + (depth > 1 ? ' c-primary-menu__sub-menu--deep' : '');
	};

	/**
  * @summary Returns classes attribute value for a drawer menu list.
  *
  * @param {Number} depth The depth of the menu.
  * @returns {String} The class attribute value.
  */


	Menu.prototype.drawerMenuClasses = function drawerMenuClasses(depth) {
		var baseName = 'c-drawer-menu__menu';
		return baseName + ' ' + baseName + '--' + (depth === 0 ? 'top' : 'sub');
	};

	Menu.prototype.render = function render(_ref) {
		var menuTree = _ref.menuTree,
		    _ref$type = _ref.type,
		    type = _ref$type === undefined ? 'normal' : _ref$type,
		    _ref$depth = _ref.depth,
		    depth = _ref$depth === undefined ? 0 : _ref$depth,
		    style = _ref.style;

		var items = menuTree.map(function (item, i) {
			return (0, _preact.h)(_MenuItem2.default, (0, _extends3.default)({}, item, {
				key: depth + ':' + i,
				depth: depth,
				type: type
			}));
		});

		return (0, _preact.h)(
			'ul',
			{ 'class': this.menuClasses(type, depth), style: style },
			items
		);
	};

	return Menu;
}(_preact.Component);

exports.default = Menu;

/***/ }),

/***/ "NY/y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _Menu = __webpack_require__("BpTR");

var _Menu2 = _interopRequireDefault(_Menu);

var _MainMenuDrawer = __webpack_require__("Z8qY");

var _MainMenuDrawer2 = _interopRequireDefault(_MainMenuDrawer);

var _throttle = __webpack_require__("+X65");

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Main menu preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
/**
 * @summary Top main menu component.
 */

var MainMenu = function (_Component) {
	(0, _inherits3.default)(MainMenu, _Component);

	function MainMenu(props) {
		(0, _classCallCheck3.default)(this, MainMenu);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.state = {
			shownCount: 0
		};

		_this.itemElements = [];
		return _this;
	}

	MainMenu.prototype.componentDidMount = function componentDidMount() {
		this.resizeWatch();
		this.resizeWatch = (0, _throttle2.default)(this.resizeWatch.bind(this), 200);
		window.addEventListener('resize', this.resizeWatch);
	};

	MainMenu.prototype.componentWillUnmount = function componentWillUnmount() {
		window.removeEventListener('resize', this.resizeWatch);
	};

	/**
  * @summary Maintains single line top-level layout of the menu items.
  *
  * @listens document:resize
  */


	MainMenu.prototype.resizeWatch = function resizeWatch() {
		var first = this.itemElements[0];

		var shownCount = 1;
		for (var _iterator = this.itemElements.slice(1), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var element = _ref;

			if (element.offsetTop > first.offsetTop) {
				break;
			}

			shownCount++;
		}

		if (shownCount === this.itemElements.length) {
			shownCount = 999;
		}

		this.setState({
			shownCount: shownCount
		});
	};

	MainMenu.prototype.render = function render(_ref2, _ref3) {
		var _this2 = this;

		var menuTree = _ref2.menuTree,
		    localizedStrings = _ref2.localizedStrings;
		var shownCount = _ref3.shownCount;

		var topMenuTree = menuTree.map(function (item, i) {
			return (0, _assign2.default)({}, item, {
				itemRef: function itemRef(element) {
					return _this2.itemElements[i] = element;
				},
				hidden: i >= shownCount
			});
		});

		var style = this.itemElements.length > 0 && {
			height: this.itemElements[0].offsetHeight + 'px',
			visibility: shownCount < 2 ? 'hidden' : ''
		};

		return (0, _preact.h)(
			'div',
			{ 'class': 'c-primary-menu' },
			(0, _preact.h)(_Menu2.default, { menuTree: topMenuTree, style: style }),
			(0, _preact.h)(_MainMenuDrawer2.default, {
				classes: 'c-primary-menu__drawer',
				menuTree: menuTree,
				localizedStrings: localizedStrings,
				hide: shownCount > this.itemElements.length
			})
		);
	};

	return MainMenu;
}(_preact.Component);

exports.default = MainMenu;
;

/***/ }),

/***/ "WM5d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @summary Instantiates SVG4Everybody polyfill conditionally.
 */

var newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/;
var webkitUA = /\bAppleWebKit\/(\d+)\b/;
var olderEdgeUA = /\bEdge\/12\.(\d+)\b/;
var edgeUA = /\bEdge\/.(\d+)\b/;

/*
 * Conditionally loads pollyfill, based on conditional taken from the polyfill
 * source code.
 */
if (newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && window.top !== window.self) {
  __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "YB9v")).then(function (init) {
    return init({ polyfill: true });
  });
}

/***/ }),

/***/ "XPoA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _fontfaceobserver = __webpack_require__("FG6U");

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fonts = [new _fontfaceobserver2.default('Open Sans', { weight: 300 }).load(), new _fontfaceobserver2.default('Open Sans', { weight: 400 }).load(), new _fontfaceobserver2.default('Open Sans', { weight: 700 }).load()]; /**
                                                                                                                                                                                                                              * Prevents FOIT of custom webfonts in favour of FOUT.
                                                                                                                                                                                                                              *
                                                                                                                                                                                                                              * @summary Webfont loader.
                                                                                                                                                                                                                              * @requires FontFaceObserver
                                                                                                                                                                                                                              */

_promise2.default.all(fonts).then(function () {
	document.body.classList.add('t-open-sans');
});

/***/ }),

/***/ "Xpq3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _Menu = __webpack_require__("BpTR");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Main menu item preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */


/**
 * @summary Contains the main menu item preact component.
 */

var MenuItem = function (_Component) {
	(0, _inherits3.default)(MenuItem, _Component);

	function MenuItem(props) {
		(0, _classCallCheck3.default)(this, MenuItem);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.state = {
			open: false
		};

		_this.indirectClose = _this.indirectClose.bind(_this);
		_this.onTouch = _this.onTouch.bind(_this);
		_this.onRef = _this.onRef.bind(_this);
		return _this;
	}

	MenuItem.prototype.componentDidMount = function componentDidMount() {
		if (this.props.children.length > 0) {
			document.addEventListener('touchstart', this.indirectClose);
		}
	};

	MenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
		document.removeEventListener('touchstart', this.indirectClose);
	};

	/**
  * @summary Preact ref call.
  *
  * @param {Node} element The element to reference.
  */


	MenuItem.prototype.onRef = function onRef(element) {
		this.ele = element;

		if (typeof this.props.itemRef === 'function') {
			this.props.itemRef(element);
		}
	};

	/**
  * @summary Queries whether an element is a child of this component's root.
  *
  * @param {Node} element The element to query about.
  * @returns {bool} Returns true if the given element is a child.
  */


	MenuItem.prototype.isChild = function isChild(element) {
		if (element === null) {
			return false;
		}

		if (element === this.ele) {
			return true;
		}

		return this.isChild(element.parentElement);
	};

	/**
  * @summary Closes the submenu (if any and open) on elsewhere touch.
  *
  * @listens document:touchstart
  *
  * @param {TouchEvent} event The object representing the touch event.
  */


	MenuItem.prototype.indirectClose = function indirectClose(event) {
		if (this.state.open && !this.isChild(event.srcElement)) {
			this.setState({
				open: false
			});
		}
	};

	/**
  * @summary Opens the submenu (if any) on touch.
  *
  * @listens document:touchend
  *
  * @param {TouchEvent} event The object representing the touch event.
  */


	MenuItem.prototype.onTouch = function onTouch(event) {
		if (this.props.children.length > 0 && !this.state.open) {
			event.preventDefault();

			this.setState({
				open: true
			});
		}
	};

	/**
  * @summary Returns classes attribute value to add to an anchor element.
  *
  * @returns {String} The class attribute value.
  */


	MenuItem.prototype.linkClasses = function linkClasses() {
		var baseName = (this.props.type === 'normal' ? 'c-primary-menu' : 'c-drawer-menu') + '__link';
		var classes = baseName + ' ' + baseName + '--' + (this.props.depth === 0 ? 'top' : 'sub');

		if (this.props.activeTrail) {
			classes += ' is-active-trail';
		}

		return classes;
	};

	MenuItem.prototype.render = function render(_ref, _ref2) {
		var url = _ref.url,
		    title = _ref.title,
		    depth = _ref.depth,
		    type = _ref.type,
		    hidden = _ref.hidden,
		    _ref$children = _ref.children,
		    children = _ref$children === undefined ? [] : _ref$children;
		var open = _ref2.open;

		return (0, _preact.h)(
			'li',
			{
				onTouchEnd: this.onTouch,
				'class': open ? 'is-open' : '',
				style: hidden ? 'visibility: hidden' : '',
				ref: this.onRef
			},
			(0, _preact.h)(
				'a',
				{ href: url, 'class': this.linkClasses() },
				title
			),
			children.length > 0 && (0, _preact.h)(_Menu2.default, { menuTree: children, depth: depth + 1, type: type })
		);
	};

	return MenuItem;
}(_preact.Component);

exports.default = MenuItem;

/***/ }),

/***/ "Z8qY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__("rMlB");

var _Menu = __webpack_require__("BpTR");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Main menu drawer menu preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
/**
 * @summary Contains main menu drawer menu preact component.
 */

var MainMenuDrawer = function (_Component) {
	(0, _inherits3.default)(MainMenuDrawer, _Component);

	function MainMenuDrawer(props) {
		(0, _classCallCheck3.default)(this, MainMenuDrawer);

		var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

		_this.state = {
			open: false,
			focus: false
		};

		_this.focusTargets = {};
		_this.docBody = document.body;

		_this.open = _this.open.bind(_this);
		_this.close = _this.close.bind(_this);
		return _this;
	}

	/**
  * @summary Opens the drawer from a click event.
  *
  * @listens document:click
  *
  * @param {Event} event The event from which the open command comes from.
  */


	MainMenuDrawer.prototype.open = function open(event) {
		this.setState({
			open: true,

			// Focus to drawer title if keyboard synthetic click (e.g. enter key)
			focus: event.x + event.y === 0 && 'drawerTitle'
		});
	};

	/**
  * @summary Closes the drawer from a click event.
  *
  * @listens document:click
  *
  * @param {Event} event The event from which the close command comes from.
  */


	MainMenuDrawer.prototype.close = function close(event) {
		this.setState({
			open: false,

			// Focus to open button if keyboard synthetic click (e.g. enter key)
			focus: event.x + event.y === 0 && 'openButton'
		});
	};

	MainMenuDrawer.prototype.componentDidMount = function componentDidMount() {

		// Add Esc to close the drawer
		document.addEventListener('keydown', this.close);
	};

	MainMenuDrawer.prototype.componentWillUnmount = function componentWillUnmount() {

		// Remove Esc event listener
		document.removeEventListener('keydown', this.close);
	};

	MainMenuDrawer.prototype.componentDidUpdate = function componentDidUpdate() {
		var focusTarget = this.state.focus;
		if (focusTarget && focusTarget in this.focusTargets) {
			this.focusTargets[focusTarget].focus();
		}
	};

	/**
  * @summary Modifies scroll-ability of the document body.
  *
  * @param {bool} open Whether this drawer component state is set to open.
  */


	MainMenuDrawer.prototype.modifyBodyScroll = function modifyBodyScroll(open) {
		var beforeWidth = this.docBody.offsetWidth;

		// Remove scrolling from body
		this.docBody.style.overflow = open ? 'hidden' : '';

		// Compensate for possible scrollbar layout jump
		var widthDiff = this.docBody.offsetWidth - beforeWidth;
		this.docBody.style.paddingRight = open ? widthDiff + 'px' : '';
	};

	MainMenuDrawer.prototype.render = function render(_ref, _ref2) {
		var _this2 = this;

		var menuTree = _ref.menuTree,
		    classes = _ref.classes,
		    localizedStrings = _ref.localizedStrings,
		    hide = _ref.hide;
		var open = _ref2.open;

		this.modifyBodyScroll(open);

		return (0, _preact.h)(
			'div',
			{ 'class': classes + ' c-drawer-menu', style: hide && 'display:none' },
			(0, _preact.h)(
				'button',
				{
					ref: function ref(button) {
						return _this2.focusTargets.openButton = button;
					},
					'class': 'c-drawer-menu__open-btn',
					'aria-controls': 'drawer-menu',
					'aria-hidden': String(open),
					tabindex: open ? -1 : 0,
					onClick: this.open
				},
				localizedStrings.open
			),
			(0, _preact.h)(
				'button',
				{
					'class': 'c-drawer-menu__close-btn',
					'aria-controls': 'drawer-menu',
					'aria-hidden': String(!open),
					tabindex: open ? 0 : -1,
					onClick: this.close
				},
				localizedStrings.close
			),
			(0, _preact.h)(
				'div',
				{ id: 'drawer-menu', 'class': 'c-drawer-menu__drawer', 'aria-expanded': String(open) },
				(0, _preact.h)(
					'h2',
					{
						'class': 'c-drawer-menu__title',
						ref: function ref(drawerTitle) {
							return _this2.focusTargets.drawerTitle = drawerTitle;
						},
						tabIndex: '-1'
					},
					localizedStrings.title
				),
				(0, _preact.h)(_Menu2.default, { menuTree: menuTree, type: 'drawer' })
			)
		);
	};

	return MainMenuDrawer;
}(_preact.Component);

exports.default = MainMenuDrawer;

/***/ }),

/***/ "ZcfW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _preact = __webpack_require__("rMlB");

var _MainMenu = __webpack_require__("NY/y");

var _MainMenu2 = _interopRequireDefault(_MainMenu);

var _parseHtml = __webpack_require__("rBQi");

var _parseHtml2 = _interopRequireDefault(_parseHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Parses HTML structure into a menu tree structure.
 *
 * @param {HTMLUListElement} listElement The root menu list element.
 * @returns {Object[]} The structure of the menu.
 */
function parseMenu(listElement) {
	return (0, _from2.default)(listElement.children).map(function (listItem) {
		var link = listItem.querySelector('a');
		var subMenu = listItem.querySelector('ul');

		return {
			title: link.textContent,
			url: link.href,
			children: subMenu ? parseMenu(subMenu) : [],
			activeTrail: link.classList.contains('is-active-trail')
		};
	});
} /**
   * @summary Primary menu enhancer.
   */

var root = document.getElementById('js-main-menu');
var menuMarkup = root.querySelector('.c-primary-menu');

new _promise2.default(function (resolve) {
	return resolve(parseMenu((0, _parseHtml2.default)(menuMarkup.textContent)[0]));
}).then(function (menuTree) {
	menuMarkup.parentElement.removeChild(menuMarkup);
	(0, _preact.render)((0, _preact.h)(_MainMenu2.default, { menuTree: menuTree, localizedStrings: wp_data.loweMenuStrings }), root);
});

/***/ }),

/***/ "hpRy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @summary Sets Webpack public path.
 */

/* eslint-disable camelcase, no-unused-vars */
/* global __webpack_public_path__ */

__webpack_require__.p = wp_data.path;

/***/ }),

/***/ "pZCz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Google analytics tracking.
 */
/* eslint-disable */

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag('js', new Date());

gtag('config', wp_data.gaId);

/***/ }),

/***/ "rBQi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Contains a utility that parses a string into HTML objects.
 */

/**
 * @summary Parses a string into HTML objects.
 *
 * @param {String} markup The HTML fragment string to parse.
 * @returns {HTMLElement[]} The HTML element objects.
 */
exports.default = function (markup) {
  var slave = document.createElement('div');
  slave.innerHTML = markup;
  return (0, _from2.default)(slave.children);
};

/***/ }),

/***/ "vGYV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

__webpack_require__("hpRy");

__webpack_require__("XPoA");

__webpack_require__("pZCz");

__webpack_require__("3YAd");

__webpack_require__("ZcfW");

__webpack_require__("WM5d");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @summary Main JS entry point.
 */

if (false) {
	import( /* webpackChunkName: "preactDevtools" */'preact/devtools');
}

(0, _from2.default)(document.querySelectorAll('.js-inview-list[data-selector]')).forEach(function (list) {
	var selector = list.getAttribute('data-selector');
	var items = list.querySelectorAll(selector);
	if (items.length > 0) {
		__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "FKwn")).then(function (module) {
			new module.default((0, _from2.default)(items));
		});
	}
});

if ('wc_data' in window) {
	(0, _from2.default)(document.querySelectorAll('.product-addon--file_upload label')).filter(function (label) {
		return !!label.control || !!label.getAttribute('for');
	}).forEach(function (label) {
		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "ULBq")).then(function (module) {
			module.default(label);
		});
	});

	// Special description positioning
	var selector = '.product-addon--file_upload > .product-addon__extra';
	var extraEle = document.querySelector(selector);
	if (extraEle) {
		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "GY2V")).then(function (module) {
			return module.default(extraEle);
		});
	}
}

var featuredProducts = document.getElementById('js-featured-products');
if (featuredProducts) {
	__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "aR3g")).then(function (module) {
		return module.default(featuredProducts);
	});
}

var cartForm = document.querySelector('form.woocommerce-cart-form');
if (cartForm) {
	__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "WZ9E")).then(function (module) {
		return module.default(cartForm);
	});
}

/***/ })

},["vGYV"]);


// WEBPACK FOOTER //
// main.9f0650d4f815d5858660.js